import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ExcelService } from 'src/app/services/excel.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UserdataService } from 'src/app/services/userdata.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import Swal from 'sweetalert2';
import { ReferralType } from 'src/app/enum/ReferralType';

@Component({
  selector: 'app-manage-referral-friends',
  templateUrl: './manage-referral-friends.component.html',
  styleUrls: ['./manage-referral-friends.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageReferralFriendsComponent implements OnInit {

  data: any[] = [];
  dataExcel: any = [];
  dataSource = new MatTableDataSource<any>(this.data);
  excelColumns: string[];
  displayedColumns: string[] = ['ReferrerName', 'ReferrerEmail', 'ReferralType', 'ReferredCustomerName', 'ReferredCustomerEmail', 'RefereeCustomerContactNumber', 'RefereeApplicationNumber', 'ReferralStatus', 'Action'];
  filterOpen: boolean = false;
  excelUploadOpen: boolean = false;
  filterSearchForm: any;
  file: File;
  fileName: string;
  isFileSelected: boolean;
  form: FormGroup;
  referralType: any;
  ReferralTypeEnum = ReferralType

  constructor(
    private formBuilder: FormBuilder,
    private userDataService: UserdataService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
  ) { }

  ngOnInit(): void {
    this.getTableData(null);
    this.filterSearchForm = this.formBuilder.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });
    this.form = this.formBuilder.group({
      AttachmentFileName: [],
    })
  }

  searchClick() {
    if (this.filterSearchForm.invalid) {
      this.filterSearchForm.markAllAsTouched();
      this.toastr.showError("Please select start date and end date");
      return;
    }

    var data = this.filterSearchForm.getRawValue();
    if (data.startDate && data.endDate && moment(data.endDate).isBefore(moment(data.startDate))) {
      this.filterSearchForm.markAllAsTouched();
      this.toastr.showError("End Date should be greater than Start Date");
      return;
    }
    data.startDate = this.filterSearchForm.value.startDate ? moment(this.filterSearchForm.value.startDate).format("YYYY-MM-DD") : null;
    data.endDate = this.filterSearchForm.value.endDate ? moment(this.filterSearchForm.value.endDate).format("YYYY-MM-DD hh:mm:ss") : null;
    this.userDataService.GetReferralDetailsbyFilter(data).subscribe((res: any) => {
      this.data = res.referralViewModel;
      this.dataExcel = res.referralViewModel;
      this.dataSource = new MatTableDataSource<any>(this.data);
    });
  }

  clearFilter() {
    this.filterSearchForm.reset();
    this.form.reset();
    this.getTableData(null);

  }
  exportAsXLSX() {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "Referrer Name",
        "Referrer Email",
        "Referee Name",
        "Referee Email",
        "Referee Contact Number",
        "Referee Application Number",
        "Referral Status",
        "Referral Type"
      ];
      exportData.forEach((a, index) => {
        excelList.push({
          "Referrer Name": a.existingUserName,
          "Referrer Email": a.existingUserEmail,
          "Referee Name": a.newUserFirstName + ' ' + a.newUserLastName,
          "Referee Email": a.newUserEmail,
          "Referee Contact Number" : a.newUserMobileNumber,
          "Referee Application Number": a.referenceNumber,
          "Referral Status": a.customerReferralStatus,
          "Referral Type": a.referralTypeName
        });
      });
      this.excelService.exportAsExcelFile(excelList, "Customer_Referral_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }

  getTableData(data) {
    this.userDataService.GetReferralDetails().subscribe((res: any) => {
      this.data = res.referralViewModel
      this.dataExcel = res.referralViewModel;
      this.dataSource = new MatTableDataSource<any>(this.data);
    });
  }
  applyFilter(event: Event) {
    const filterValue = ((event.target as HTMLInputElement).value || '');
    const normalized = filterValue.trim().toLowerCase();

    // Set predicate first so the next assignment to `filter` triggers evaluation
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      // Referrer Name
      const referrerName = data && data.existingUserName ? String(data.existingUserName).toLowerCase() : '';
      // Referrer Email
      const referrerEmail = data && data.existingUserEmail ? String(data.existingUserEmail).toLowerCase() : '';
      // Referred Customer Name
      const first = data && data.newUserFirstName ? String(data.newUserFirstName).toLowerCase() : '';
      const last = data && data.newUserLastName ? String(data.newUserLastName).toLowerCase() : '';
      const referredName = (first + ' ' + last).trim();
      // Referred Customer Email
      const referredEmail = data && data.newUserEmail ? String(data.newUserEmail).toLowerCase() : '';
      // Referee Application Number
      const appNumber = data && data.referenceNumber ? String(data.referenceNumber).toLowerCase() : '';
      // Referral Status
      const status = data && data.customerReferralStatus ? String(data.customerReferralStatus).toLowerCase() : '';

      // Return true if filter matches any field
      return (
        referrerName.includes(filter) ||
        referrerEmail.includes(filter) ||
        referredName.includes(filter) ||
        referredEmail.includes(filter) ||
        appNumber.includes(filter) ||
        status.includes(filter)
      );
    };

    // Assign filter after predicate is set
    this.dataSource.filter = normalized;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  MarkAsPaidd(referralId: any) {
    if (referralId) {
      Swal.fire({
        text: 'Are you sure you want to mark this referral as Paid?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#7D32DE',
        cancelButtonColor: '#23C00A',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.userDataService.MarkReferralAsPaid(referralId).subscribe((res: any) => {
            if (res) {
              this.toastr.showSuccess("Referral marked as Paid successfully");
              this.getTableData(null);
            } else {
              this.toastr.showError(res.message || "Something went wrong");
            }
          }, error => {
            this.toastr.showError(error.message || "Something went wrong");
          });
        }
      });
    }
  }




  selectFile() {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();

    inputElement.addEventListener('change', async (event: any) => {
      const files: FileList = (event.target as HTMLInputElement).files;

      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }
      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload only one file at a time', 'warning');
        return;
      }
      this.file = files[0];
      this.fileName = this.file.name;
      const fileExtension = this.fileName.split('.').pop().toLowerCase();
      const validExtensions = ['csv', 'xlsx', 'xls'];
      const validMimeTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

      const isValidExtension = validExtensions.includes(fileExtension);
      const isValidMimeType = validMimeTypes.includes(this.file.type);

      if (!isValidExtension || !isValidMimeType) {
        Swal.fire(
          'Warning',
          `Please upload a correct file format (csv, xlsx, xls)`,
          'warning'
        );
        this.fileName = '';
        this.isFileSelected = false;
        document.body.removeChild(inputElement);
        return;
      }
      this.isFileSelected = true;
      this.form.controls['AttachmentFileName'].setValue(this.fileName);
      document.body.removeChild(inputElement);
    });
  }
  upload() {
    if (!this.file) {
      this.toastr.showError("Please select a file to upload");
      this.form.markAllAsTouched();
      return;
    }
    let formData: FormData = new FormData();
    formData.append('file', this.file);

    this.userDataService.ImportReferralPaidUsers(formData).subscribe({

      next: (res) => {

        // 📄 CSV FILE
        this.toastr.showSuccess(res.message);
        this.getTableData(null);
        this.excelUploadOpen = false;
        this.resetFile();

      },
      error: (res) => {
        debugger
        console.error('FULL ERROR:', res);
        console.error('ERROR BODY:', res.error);
        console.dir(res, { depth: null });
        if (res.error.type === 'csv') {

          const binary = atob(res.error.data);
          const bytes = new Uint8Array(binary.length);

          for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
          }

          const blob = new Blob([bytes], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = res.error.fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          return;
        }

      }

    });

  }
  reset() {
    const txt = 'Are you sure you want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.fileName = '';
        this.isFileSelected = false;
        this.form.controls['AttachmentFileName'].setValue(this.fileName);
      }
    });
  }

  resetFile() {
    this.fileName = '';
    this.isFileSelected = false;
    this.form.controls['AttachmentFileName'].setValue('');
  }



}
